import { jsx } from 'react/jsx-runtime';
import { styled } from '@flex-design-system/stitches-react';
import { Primitive } from '@radix-ui/react-primitive';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { tabsItemSlot } from './itemSlot.vanilla.mjs';

const TabsItemSlotImpl = forwardRef(
  ({ className: classNameFromProps, ...props }, forwardedRef) => {
    const className = classNames(tabsItemSlot, classNameFromProps);
    return /* @__PURE__ */ jsx(
      Primitive.div,
      {
        "data-scope": "tabs",
        "data-part": "item-slot",
        className,
        ref: forwardedRef,
        ...props
      }
    );
  }
);
const TabsItemSlot = styled(TabsItemSlotImpl);
TabsItemSlot.displayName = "Tabs.ItemSlot";
TabsItemSlot.toString = () => '[data-scope="tabs"][data-part="item-slot"]';

export { TabsItemSlot };
//# sourceMappingURL=ItemSlot.mjs.map
